import type { HTMLAttributes } from 'react';
import { cn } from '../utils';

function ErrorPage({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className={cn('flex min-h-full-page flex-col items-center justify-center gap-3 text-center', className)}
      {...props}
    />
  );
}

function ErrorPageTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h1 className={cn('font-headline font-semibold text-4xl text-foreground', className)} {...props} />;
}

function ErrorPageMessage({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('mb-2 font-light text-base text-foreground', className)} {...props} />;
}

function ErrorPageActions({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:flex-wrap sm:justify-center [&>*]:w-full sm:[&>*]:w-action-button',
        className,
      )}
      {...props}
    />
  );
}

export { ErrorPage, ErrorPageActions, ErrorPageMessage, ErrorPageTitle };
